module.exports = __webpack_public_path__ + "static/media/example04-02.1c9bdc31.svg";